import { WorkflowNode, ProjectId, WorkflowId, WorkflowNodeId, WorkflowVersionId } from '@ply-io/ply-front-shared-utilities';

import { editNodeLink as editNodeLinkGetter, getNode, isEndRunWidget, isWidget } from '@/store/modules/nodes/getters';
import { useStore } from '@/utils/store';

export const useNodesGetters = () => {
	const { getter } = useStore();
	return {
		editNodeLink:
			getter<(payload: { projectId: ProjectId; flowId: WorkflowId; nodeId: WorkflowNodeId; versionId?: WorkflowVersionId }) => string>(
				editNodeLinkGetter
			),
		getNode: getter<(nodeId: WorkflowNodeId) => WorkflowNode | undefined>(getNode),
		isEndRunWidget: getter<(nodeId: WorkflowNodeId) => boolean>(isEndRunWidget),
		isWidget: getter<(nodeId: WorkflowNodeId) => boolean>(isWidget),
	};
};
